

const formatHelper = {

/* finns även i admin */
	urlProductKey(name) {

		name = name.toLowerCase();
		name = name.replace("å", "a");
		name = name.replace("ä", "a");
		name = name.replace("ö", "o");

		var key = name.trim().replace(/[^A-Za-z0-9]/g, "-");

		key = key.replace(/--+/g, '-'); // -- 
		key = key.replace(/^-+/, '');  // börjar med - 
		key = key.replace(/-$/, '');  // slutar med - 


		return key.toLowerCase();
	}




}



export default formatHelper
